<template>
  <div class="onlineStoreGroups responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'onlineStoreGroups', label: 'Online Store Groups' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import moment from "moment";
import Entities from "@/resources/Entities";
import SearchTable from "@/components/SearchTable.vue";

import { listPageHeader } from "./inputs";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "onlineStoreGroups",
  data() {
    return {
      moment: moment,
      entity: Entities.ONLINESTOREGROUP,
      listPageHeader,
    };
  },
  components: {
    PageHeader,
    SearchTable,
  },
  mounted: function () {
    this.setPageTitle("OnlineStoreGroups");
  },
  computed: {
    ...mapGetters({
      sort: "onlineStoreGroupModule/sort",
      pagination: "onlineStoreGroupModule/pagination",
      initialFilter: "onlineStoreGroupModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "onlineStoreGroupModule/updateSort",
      updatePagination: "onlineStoreGroupModule/updatePagination",
      updateInitialFilter: "onlineStoreGroupModule/updateInitialFilter"
    }),
  }
};
</script>
